import { useMemo } from 'react'
import { useInvoices } from '../queries'
import { useStaff } from '@/api/hooks'
import { Button } from '@/components/ui/button'
import { CreateInvoiceDialog } from './create-invoice-dialog'
import { InvoiceListFilters } from './invoice-list-filters'
import { InvoiceListBulkActions } from './invoice-list-bulk-actions'
import { InvoiceListResults } from './invoice-list-results'
import { useInvoiceListFilters } from './use-invoice-list-filters'
import { useInvoiceListBulk } from './use-invoice-list-bulk'
import { resultCount } from '@/lib/utils'

export function InvoicesPage() {
  const filters = useInvoiceListFilters()
  const { page, setPage, toggleSort } = filters
  const staffQuery = useStaff({ active: true })
  const staff = useMemo(() => staffQuery.data ?? [], [staffQuery.data])
  const { data, isLoading } = useInvoices(filters.params)
  const bulk = useInvoiceListBulk(data, staff)

  return (
    <div className="mx-auto max-w-7xl space-y-4 pb-24">
      <div className="flex items-center justify-between gap-3">
        <h1 className="text-2xl font-bold tracking-tight">AP Invoices</h1>
        <CreateInvoiceDialog />
      </div>

      <InvoiceListFilters filters={filters} staff={staff} count={resultCount(data?.total, 'invoice')} />
      <InvoiceListBulkActions bulk={bulk} staff={staff} />
      <InvoiceListResults
        data={data}
        isLoading={isLoading}
        toggleSort={toggleSort}
        selectedInvoiceUuids={bulk.selectedInvoiceUuids}
        allVisibleSelected={bulk.allVisibleSelected}
        setVisibleSelection={bulk.setVisibleSelection}
        setRowSelection={bulk.setRowSelection}
      />

      <div className="flex items-center justify-between px-4 py-3">
        <p className="text-sm text-muted-foreground">
          Page {data?.page ?? 1} of {data?.pages ?? 1} ({data?.total ?? 0} total)
        </p>
        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => setPage((current) => Math.max(1, current - 1))}
            disabled={page <= 1}
          >
            Previous
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => setPage((current) => current + 1)}
            disabled={page >= (data?.pages ?? 1)}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  )
}
